import React, {useContext} from 'react'
import './Services.css'
import HeartEmoji from '../../img/heartemoji.png'
import Glasses from '../../img/glasses.png'
import Humbel from '../../img/humble.png'
import Card from '../Card/Card'
import Resume from '../Services/niketan_resume.pdf'
import {themeContext} from '../../Context'
import {motion} from 'framer-motion'


function Services() {
  const transition = {duration: 2, type: 'spring'}
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
  return (
    <div className='services' id='Services'>
        <div className="awsome">
            <span style={{color: darkMode ? 'white' : ''}}>My Awesome</span>
            <span>services!</span>
            <span>To give real service you must add something which cannot be bought or measured with money,
            <br />    
            and that is <span style={{color: 'var(--orange)'}}>sincerity and integrity.</span></span>
            <a href={Resume} download style={{width: 'max-content'}}>
              <button className='button s-button'>Download CV</button>
            </a>
            <div className='blur s-blur' style={{background: '#ABF1FF94'}}></div>
        </div>
        <div className="cards">
          <motion.div
          initial={{left: '25rem'}}
          whileInView={{left: '14rem'}}
          transition={transition}
          
          style={{left: '14rem'}}>
            <Card 
              emoji = {HeartEmoji}
              heading = {'Design'}
              detail = {'Canva, PixelLab, PicsArt, Font Awesome, Paint'}
            />
          </motion.div>
          <motion.div
          initial={{left:'-14rem'}}
          whileInView={{left: '-4rem'}}
          transition={transition}
          
          style={{top: '12rem', left: '-4rem'}}>
            <Card 
              emoji = {Glasses}
              heading = {'Developer'}
              detail = {'HTML, Python, CSS, JavaScript, ReactJs, React-Native and more...'}
            />
          </motion.div>
          <motion.div
          initial={{left: '20rem'}}
          whileInView={{left: '12rem'}}
          transition={transition}
          
          style={{top: '19rem', left: '12rem'}}>
            <Card 
              emoji = {Humbel}
              heading = {'Additional'}
              detail = {'Team Player, Supportive, Positive Attitude, Creative, Time Management'}
            />
          </motion.div>
          <div className='blur s-blur1' style={{background: "#C1F5FF"}}>

          </div>
          <div className='blur s-blur2' style={{background: "var(--purple)"}}>

          </div>
        </div>
    </div>
  )
}

export default Services